// extracted by mini-css-extract-plugin
export default {"root":"companyForm_root__csbx3","tabsNavigation":"companyForm_tabsNavigation__+CHym","tabWrapper":"companyForm_tabWrapper__mz-6p","boxed":"companyForm_boxed__x3QC7"};